import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions";
import {IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts} from "angular-2-dropdown-multiselect";
import {AdministrationUnitService} from "../../../organization/services/administration_unit_service/administration-unit.service";

@Component({
  selector: 'vb-admin-unit-multi-select',
  templateUrl: './admin-unit-multi-select.component.html',
  styleUrls: ['./admin-unit-multi-select.component.css']
})
export class AdminUnitMultiSelectComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit {

  @Input()
  selectedAdminUnits;

  adminUnits: IMultiSelectOption[];

  @Output()
  selectionChange: EventEmitter<string[]> = new EventEmitter();

  mySettings: IMultiSelectSettings = {
    enableSearch: true,
    //checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-sm btn-default btn-block',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true
  };

  // Text configuration
  myTexts: IMultiSelectTexts = {
    checkAll: 'Alle auswählen',
    uncheckAll: 'Alle abwählen',
    checked: 'Eintrag ausgewählt',
    checkedPlural: 'Einträge ausgewählt',
    searchPlaceholder: 'Suche',
    searchEmptyResult: 'Nichts gefunden...',
    searchNoRenderText: 'Tippen, um nach Namen zu filtern...',
    defaultTitle: 'Auswahl',
    allSelected: 'Alle ausgewählt',
  };

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private adminUnitService: AdministrationUnitService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.dataSubscriptions.push(this.adminUnitService.getAdminUnits().subscribe(res => {
      this.adminUnits = res.data.fetchAdminUnits.map(adminUnit => {
        return {
          id: adminUnit.cuid,
          name: adminUnit.label
        }
      });
    }));

  }


  ngAfterViewInit(): any {
    super.ngAfterViewInit();
    this.onChange();
  }

  onChange(event?) {
    this.selectionChange.emit(this.selectedAdminUnits || []);
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/components/admin-unit-multi-select/admin-unit-multi-select.component.ts